import {
  Box,
  Card,
  Grid,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { motion } from "framer-motion";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import Slideshow from "./Slideshow";
import FileReader from "../../Common/FileReader";

import img1 from "/public/images/img1.jpg";
import img2 from "/public/images/img2.jpg";
import img3 from "/public/images/img3.jpg";
import img4 from "/public/images/img4.jpg";
import img5 from "/public/images/img5.jpg";
import img6 from "/public/images/img6.jpg";
import img7 from "/public/images/img7.jpg";
import img8 from "/public/images/img8.jpg";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
    width: "100%",
    height: "100%",
  },
  categoryCard: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "30vh",
  },
  cardTitle: {
    fontSize: "2rem",
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
  },
  cardOpacity: {
    opacity: 0.5,
  },
  lgpdInfoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #031795",
    marginTop: "16px",
  },
  lgpdInfoText: {
    color: "#000",
    fontWeight: "semibold",
    marginLeft: "16px",
  },
}));

const HomePage = ({ t, history }) => {
  const classes = useStyles();
  const images = [img1, img2, img3, img4];

  return (
    <Paper className={classes.root}>
      <Grid container spacing={4}>
        <Grid
          container
          item
          direction="row"
          justify="center"
          style={{ height: "40vh" }}
        >
          <Slideshow images={images} />
        </Grid>
        <Grid container item direction="row" spacing={4} justify="center">
          <Grid item md={3} lg={3}>
            <motion.div
              className={classes.cardOpacity}
              whileHover={{ scale: 1.2, opacity: 1 }}
              whileTap={{ scale: 0.8 }}
            >
              <Card
                className={classes.categoryCard}
                style={{ backgroundImage: `url(${img8})` }}
                onClick={() => history.push("/actions")}
              >
                <Typography className={classes.cardTitle}>
                  {t("menu.actions.title")}
                </Typography>
              </Card>
            </motion.div>
          </Grid>
          <Grid item md={3} lg={3}>
            <motion.div
              className={classes.cardOpacity}
              whileHover={{ scale: 1.2, opacity: 1 }}
              whileTap={{ scale: 0.8 }}
            >
              <Card
                style={{ backgroundImage: `url(${img5})` }}
                className={classes.categoryCard}
                onClick={() => history.push("/fileManagement")}
              >
                <Typography className={classes.cardTitle}>
                  {t("menu.fileManagement.link.parent")}
                </Typography>
              </Card>
            </motion.div>
          </Grid>
          <Grid item md={3} lg={3}>
            <motion.div
              className={classes.cardOpacity}
              whileHover={{ scale: 1.2, opacity: 1 }}
              whileTap={{ scale: 0.8 }}
            >
              <Card
                className={classes.categoryCard}
                style={{ backgroundImage: `url(${img6})` }}
                onClick={() => history.push("/meetings")}
              >
                <Typography className={classes.cardTitle}>
                  {t("meeting.title")}
                </Typography>
              </Card>
            </motion.div>
          </Grid>
          <Grid item md={3} lg={3}>
            <motion.div
              className={classes.cardOpacity}
              whileHover={{ scale: 1.2, opacity: 1 }}
              whileTap={{ scale: 0.8 }}
            >
              <Card
                className={classes.categoryCard}
                style={{ backgroundImage: `url(${img7})` }}
                onClick={() => history.push("/slots")}
              >
                <Typography className={classes.cardTitle}>
                  {t("slots.title")}
                </Typography>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Grid>

      <Box className={classes.lgpdInfoContainer}>
        <InfoRoundedIcon style={{ color: "#031795" }} />

        <Typography variant="span" className={classes.lgpdInfoText}>
          {t("softwareManagement.homeAlert")}
        </Typography>
      </Box>
    </Paper>
  );
};

const withRouterHomePage = withRouter(HomePage);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const HomePageConnect = connect(null, mapDispatchToProps)(withRouterHomePage);

export default withTranslation()(HomePageConnect);
